// V0
//import Dashboard from "./old/Dashboard";
//import Settings from "./old/Settings";
//import Logs from "./old/Logs";
//import ProjectsTab from "./Pages/panels/Projects";
//import ProjectWrapper from "./old/Projects/index";
//import PartnerServers from "./old/PartnerServers";
//import PackageRagnarokPage from "./old/Ragnarok";
//import { OverviewDroplet } from "./Pages/v0/OverviewDroplet";
//import ConfigurePage from "./Pages/v0/Configuration";
//import CallbackDiscord from "./components/v0/Callbacks/CallbackDiscord";


// v1
import { Home } from "./Pages/Home";
import { ControlPanel } from "./Pages/ControlPanel";
import { PricingPage } from "./Pages/PricingPage";
import { AdminPanel } from "./Pages/AdminPanel";
//import DownloadPage from "./Pages/Download";
//import ServerList from "./Pages/Servers";

// Products page
//import RagnarokList from "./Pages/Products/Ragnarok";

// Control Panel tabs
import Deployment from "./Pages/panels/Deployment";
import Billing from "./Pages/panels/Billing";
import Admin from "./Pages/Admin";
import BookingAdmin from "./Pages/Admin/Booking";
import Booking from "./Pages/Booking";

import PackagesDashboard from "./Pages/PackagesDashboard";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import TermsOfService from "./Pages/TermsOfService";

//errors
import Forbidden from "./Pages/Error/error403"
import NotFound from "./Pages/Error/error404"
import ServerError from "./Pages/Error/error500"
import ConfigManager from "./components/Admin/ConfigManager";
import Messaging from "./Pages/Messaging/index";
import Chat from "./Pages/Messaging/chat";

const adminPanelRoutes = [
    //{
    //    index: true,
    //    path: "dashboard",
    //    element: <Dashboard />,
    //    label: "Dashboard"
    //},
    {
        path: "admin",
        element: <Admin />,
        label: "Manager"
    },
    {
        path: "bookings",
        element: <BookingAdmin />,
        label: "Bookings"
    },
    {
        path: "configs",
        element: <ConfigManager />,
        label: "Package Configs"
    },
    //{
    //    path: "projects",
    //    element: <ProjectsTab />,
    //    label: "Projects"
    //},
    //{
    //    path: "deployment",
    //    element: <Deployment />,
    //    label: "Deploy"
    //},
    //{
    //    path: "settings",
    //    element: <Settings />,
    //    label: "Settings"
    //},
    //{
    //    path: "logs",
    //    element: <Logs />,
    //    label: "Logs"
    //}
];

const controlPanelRoutes = [
    //{
    //    index: true,
    //    path: "dashboard",
    //    element: <Dashboard />,
    //    label: "Dashboard"
    //},
    //{
    //    path: "project",
    //    element: <ProjectWrapper />,
    //    label: "Project"
    //},
    //{
    //    path: "chats",
    //    element: <Chat />,
    //    label: "Chats",
    //    auth: true
    //},
    {
        path: "packages",
        element: <PackagesDashboard />,
        label: "Packages"
    },
    
    {
        path: "deployments",
        element: <Deployment />,
        label: "Deploy"
    },
    //{
    //    path: "settings",
    //    element: <Settings />,
    //    label: "Settings"
    //},
    {
        path: "billing",
        element: <Billing />,
        label:"Billing"
    },
    //{
    //    path: "logs",
    //    element: <Logs />,
    //    label: "Logs"
    //}
];

const packagesPageRoutes = [
    //{
    //    path: "servers",
    //    element: <PackageRagnarokPage />,
    //    label: "Ragnarok"
    //},
    //{
    //    path: "ro",
    //    element: <RagnarokList />,
    //    label: "Ragnarok"
    //},
];

export const AboutRoutes = [
    {
        path: "privacy",
        element: <PrivacyPolicy />,
        label: "Privacy Policy"
    },
    {
        path: "termsofservice",
        element: <TermsOfService />,
        label: "Terms of Service"
    },
];


const shopRoutes = [
    {
        path: "booking",
        element: <Booking />,
        label: "Appointments",
        auth: true
    }
    //{
    //    path: "messages",
    //    element: <Messaging />,
    //    label: "Messages",
    //    auth: true
    //}
];

export const navRoutes = [
    {
        path: "/packages",
        element: <PricingPage />,
        label: "Packages"
    },
    //{
    //    path: "/downloads",
    //    element: <DownloadPage />,
    //    label: "Download"
    //},
    //{
    //    path: "/packages",
    //    label: "Packages",
    //    children: packagesPageRoutes
    //},
    {
        path: "booking",
        children: shopRoutes,
        label: "Shop",
        auth: true
    },
    {
        path: "/cp",
        element: <ControlPanel />,
        children: controlPanelRoutes,
        label: "Control Panel",
        auth: true
    },
    {
        path: "/ap",
        children: adminPanelRoutes,
        label: "Admin",
        admin: true,
        auth: true
    },
    //{
    //    path: "/me",
    //    element: <Profile />,
    //    label: "My Account",
    //    auth: true
    //},
    {
        path: "/data",
        label: "About",
        children: AboutRoutes
    },
];


const baseRoutes = [
    {
        index: true,
        element: <Home />
    },
    //{
    //    path: "/srv/:id",
    //    element: <OverviewDroplet />
    //},
    //{
    //    path: "/configure/:projectId",
    //    element: <ConfigurePage />
    //},
    //{
    //    path: "/socials/discord/callback",
    //    element: <CallbackDiscord />
    //},
    //{
    //    path: "/partners",
    //    element: <PartnerServers />
    //}
];

const errorRoutes = [
    {
        path: "/403",
        element: <Forbidden />
    },
    {
        path: "/500",
        element: <ServerError />
    },
    {
        path: "/404",
        element: <NotFound />
    },
    // IMPORTANT: catch-all must be last
    {
        path: "*",
        element: <NotFound />
    }
]
const AppRoutes = [...errorRoutes, ...baseRoutes, ...navRoutes, ...AboutRoutes];

export default AppRoutes;
